import { $ } from "@/plug/Axios";

export default {
  /**
   * 合伙人余额变动记录
   */
  amountRecord_listIncomeRecord: {
    /*
     * 提成金额变动记录列表-账户资金
     * partnerId 合伙人ID (integer query required)
     * periodId 周期ID (integer query )
     */
    get: (p, c) => $.get("/api/ems/partner/amountRecord/listIncomeRecord", p, c)
  },
  amountRecord_listIncomeRecordForClient: {
    /*
     * 提成金额变动记录列表-c端
     * periodId 周期ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/partner/amountRecord/listIncomeRecordForClient", p, c)
  },

  /**
   * 合伙人C端登录相关接口
   */
  client_changePassword: {
    /*
     * 修改密码
     * oldPassword 旧密码 (string query )
     * password 密码 (string query )
     */
    put: (p, c) => $.put("/api/ems/partner/client/changePassword", p, c)
  },
  client_listBgImg: {
    /*
     * 获取背景图模板
     * id 行id (integer query required)
     * type 类型：招生老师或合伙人 (string query required)
     */
    get: (p, c) => $.get("/api/ems/partner/client/listBgImg", p, c)
  },
  client_partnerInfoForClient: {
    /*
     * 个人基本信息
     */
    get: (p, c) => $.get("/api/ems/partner/client/partnerInfoForClient", p, c)
  },
  client_register: {
    /*
     * 注册合伙人-C端
     * belongId 分享二维码识别出来的ID (integer query required)
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     */
    post: (p, c) => $.post("/api/ems/partner/client/register", p, c)
  },
  client_signIn: {
    /*
     * 登录
     * password 密码 (string query )
     * phone 手机号 (string query )
     * signCode 登录码 (string query )
     * type 类型（微信）：公众号,小程序,APP (string query )
     */
    post: (p, c) => $.post("/api/ems/partner/client/signIn", p, c)
  },
  client_signInfo: {
    /*
     * 登录信息
     */
    get: (p, c) => $.get("/api/ems/partner/client/signInfo", p, c)
  },
  client_signOut: {
    /*
     * 退出登录
     * unbind 是否解除绑定：是，否 (string query )
     */
    delete: (p, c) => $.delete("/api/ems/partner/client/signOut", p, c)
  },

  /**
   * 合伙人线索
   */
  clue_changePartner: {
    /*
     * 变更合伙人
     * id id (integer query required)
     * newPartnerId 新合伙人 (integer query required)
     */
    put: (p, c) => $.put("/api/ems/partner/clue/changePartner", p, c)
  },
  clue_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/partner/clue/list", p, c)
  },
  clue_listForClient: {
    /*
     * 我的线索列表-c端
     * hasFinish 是否已成交 (string query )
     * periodId 周期id (integer query )
     */
    get: (p, c) => $.get("/api/ems/partner/clue/listForClient", p, c)
  },
  clue_scanCodeForClient: {
    /*
     * c端扫码录入线索，合伙人的二维码
     * id 二维码识别出来的id (integer query required)
     * name 线索名称 (string query required)
     * phone 线索手机号 (string query required)
     */
    post: (p, c) => $.post("/api/ems/partner/clue/scanCodeForClient", p, c)
  },
  clue_testCancel: {
    /*
     * 测试-合同流失时调用
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/partner/clue/testCancel", p, c)
  },
  clue_testDeal: {
    /*
     * 测试-合同成交时调用
     * schoolRollId 合同编号 (integer query required)
     */
    post: (p, c) => $.post("/api/ems/partner/clue/testDeal", p, c)
  },

  /**
   * 合伙人周期档位
   */
  config: {
    /*
     * 添加编辑
     * endTime 结束时间 (string query required)
     * id id (integer query )
     * name 名称 (string query required)
     * startTime 开始时间 (string query required)
     */
    post: (p, c) => $.post("/api/ems/partner/config", p, c),

    /*
     * 删除-线索数量大于0不可删
     * id 行id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/partner/config", p, c)
  },
  config_addBgImg: {
    /*
     * 添加背景图模板
     * bgImgStr 七牛地址，多个逗号隔开 (string query required)
     * id 行id (integer query required)
     * type 类型：招生老师或合伙人 (string query required)
     */
    post: (p, c) => $.post("/api/ems/partner/config/addBgImg", p, c)
  },
  config_getCurrentPeriod: {
    /*
     * 查询当前周期
     * refreshCatch 是否刷新缓存 (boolean query required)
     */
    get: (p, c) => $.get("/api/ems/partner/config/getCurrentPeriod", p, c)
  },
  config_getSelfPoster: {
    /*
     * 查看我的海报-招生老师
     */
    get: (p, c) => $.get("/api/ems/partner/config/getSelfPoster", p, c)
  },
  config_init: {
    /*
     * 初始化
     */
    post: (p, c) => $.post("/api/ems/partner/config/init", p, c)
  },
  config_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/partner/config/list", p, c)
  },
  config_listBgImg: {
    /*
     * 获取背景图模板
     * id 行id (integer query required)
     * type 类型：招生老师或合伙人 (string query required)
     */
    get: (p, c) => $.get("/api/ems/partner/config/listBgImg", p, c)
  },
  config_listLevel: {
    /*
     * 档位列表
     * id 行id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/partner/config/listLevel", p, c)
  },
  config_listLevelName: {
    /*
     * 简易档位名称列表
     * periodId periodId (integer query )
     */
    get: (p, c) => $.get("/api/ems/partner/config/listLevelName", p, c)
  },
  config_listName: {
    /*
     * 简易周期名称列表
     */
    get: (p, c) => $.get("/api/ems/partner/config/listName", p, c)
  },
  config_listSimple: {
    /*
     * 简易周期列表
     */
    get: (p, c) => $.get("/api/ems/partner/config/listSimple", p, c)
  },
  config_listSimpleLevel: {
    /*
     * 简易档位列表
     * periodId periodId (integer query )
     */
    get: (p, c) => $.get("/api/ems/partner/config/listSimpleLevel", p, c)
  },
  config_listSimplePeriod: {
    /*
     * 简易周期列表-带时间
     */
    get: (p, c) => $.get("/api/ems/partner/config/listSimplePeriod", p, c)
  },
  config_refreshCurrentPeriod: {
    /*
     * 刷新当前周期缓存
     */
    post: (p, c) => $.post("/api/ems/partner/config/refreshCurrentPeriod", p, c)
  },
  config_removeLevel: {
    /*
     * 删除档位-线索数量大于0不可删
     * id 档位列表id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/partner/config/removeLevel", p, c)
  },
  config_saveLevel: {
    /*
     * 添加编辑档位
     * contractIncomeAmount 线索成交提成 (number query required)
     * id id (integer query )
     * name 名称 (string query required)
     * periodId 周期ID (integer query required)
     * validContractCount 触发档位条件(有效合同数量min) (integer query required)
     */
    post: (p, c) => $.post("/api/ems/partner/config/saveLevel", p, c)
  },
  config_saveSelfPoster: {
    /*
     * 保存我的海报-招生老师
     * url 海报七牛地址 (string query )
     */
    post: (p, c) => $.post("/api/ems/partner/config/saveSelfPoster", p, c)
  },

  /**
   * 合伙人
   */
  partner: {
    /*
     * 添加合伙人(后端)
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     */
    post: (p, c) => $.post("/api/ems/partner/partner", p, c),

    /*
     * 编辑合伙人(后端)
     * ableStatus 启用禁用 (string query required)
     * id ID (integer query required)
     * name 姓名 (string query required)
     * phone 手机号 (string query required)
     */
    put: (p, c) => $.put("/api/ems/partner/partner", p, c)
  },
  partner_changeBelongAdmin: {
    /*
     * 变更推荐人
     * id id (integer query required)
     * newBelongAdminId 新推荐人 (integer query required)
     */
    put: (p, c) => $.put("/api/ems/partner/partner/changeBelongAdmin", p, c)
  },
  partner_createSharePoster: {
    /*
     * 生成分享海报
     * partnerId partnerId (integer query required)
     * qrCodeData 二维码base64 (string query )
     */
    post: (p, c) => $.post("/api/ems/partner/partner/createSharePoster", p, c)
  },
  partner_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/partner/partner/export", p, c)
  },
  partner_getSharePoster: {
    /*
     * 查询分享海报
     * periodId 周期ID (integer query )
     */
    get: (p, c) => $.get("/api/ems/partner/partner/getSharePoster", p, c)
  },
  partner_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/partner/partner/list", p, c)
  },
  partner_listSimple: {
    /*
     * 简易列表
     * ableStatus 启用状态 (string query )
     */
    get: (p, c) => $.get("/api/ems/partner/partner/listSimple", p, c)
  },
  partner_partnerInfo: {
    /*
     * 个人基本信息
     * id ID (integer query required)
     */
    get: (p, c) => $.get("/api/ems/partner/partner/partnerInfo", p, c)
  },
  partner_resetPassword: {
    /*
     * 重置密码、解冻账号
     * partnerId partnerId (integer query required)
     */
    post: (p, c) => $.post("/api/ems/partner/partner/resetPassword", p, c)
  },

  /**
   * 提现记录
   */
  withdrawal_record_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/partner/withdrawal/record/export", p, c)
  },
  withdrawal_record_exportForFinance: {
    /*
     * 导出-财务平台
     */
    get: (p, c) =>
      $.get("/api/ems/partner/withdrawal/record/exportForFinance", p, c)
  },
  withdrawal_record_finishPay: {
    /*
     * 完成打款
     * id id (integer query required)
     * payAccount 打款账号，下拉 (string query required)
     * payRemark 打款备注 (string query )
     * payTime 打款时间 (string query required)
     */
    post: (p, c) => $.post("/api/ems/partner/withdrawal/record/finishPay", p, c)
  },
  withdrawal_record_getAvailableAmount: {
    /*
     * 查询可提现金额
     * partnerId 合伙人ID (integer query required)
     * periodId 周期ID (integer query )
     */
    get: (p, c) =>
      $.get("/api/ems/partner/withdrawal/record/getAvailableAmount", p, c)
  },
  withdrawal_record_getDetail: {
    /*
     * 详情
     * id id (integer query required)
     */
    get: (p, c) => $.get("/api/ems/partner/withdrawal/record/getDetail", p, c)
  },
  withdrawal_record_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/partner/withdrawal/record/list", p, c)
  },
  withdrawal_record_listForFinance: {
    /*
     * 列表-财务平台
     */
    get: (p, c) =>
      $.get("/api/ems/partner/withdrawal/record/listForFinance", p, c)
  },
  withdrawal_record_listRecordForClient: {
    /*
     * 我的提现记录-c端
     */
    get: (p, c) =>
      $.get("/api/ems/partner/withdrawal/record/listRecordForClient", p, c)
  },
  withdrawal_record_refuse: {
    /*
     * 打回拒绝
     * id id (integer query required)
     * refuseReason 拒绝理由 (string query required)
     */
    post: (p, c) => $.post("/api/ems/partner/withdrawal/record/refuse", p, c)
  },
  withdrawal_record_withdrawalForClient: {
    /*
     * 申请提现-c端
     * accountName 收款人姓名 (string query required)
     * amount 提现金额 (number query required)
     * payAccount 收款账号 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/partner/withdrawal/record/withdrawalForClient", p, c)
  }
};
